var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.133 16.134v-5.87a.73.73 0 01.733-.73c.406 0 .734.326.734.73v6.606a.73.73 0 01-.734.73H.734A.731.731 0 010 16.867V.733C0 .329.326 0 .73 0h6.607a.73.73 0 01.73.734.731.731 0 01-.73.733h-5.87v14.667h14.666zm0-13.63l-9.432 9.432A.733.733 0 115.664 10.9l9.432-9.432h-2.632a.733.733 0 010-1.467h4.405a.728.728 0 01.73.731v4.405a.733.733 0 01-1.467 0l.001-2.632z",
    clipRule: "evenodd"
  })));
};
export default SvgExternalLink;